export default __webpack_public_path__ + "static/media/bnr8.72933430.jpg";